import React, { useEffect, useRef, useState } from "react";
import { formatPrice } from "../../utils/formatPrice";

function OrderSummarySidebar({
  categorizedCart,
  cart,
  config,
  deliveryFee,
  totalDiscount,
  totalPriceDisplay,
  totalPriceHT,
  noCheckout,
  showDeliveryFee = true,
  showPartnerDiscount = true,
}) {
  const scrollContainerRef = useRef(null);
  const [atBottom, setAtBottom] = useState(false);
  const shouldApplyScroll = cart.length >= 9;

  useEffect(() => {
    if (!shouldApplyScroll) return;

    const handleScroll = () => {
      const container = scrollContainerRef.current;
      if (!container) return;

      const isAtBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight < 5;

      setAtBottom(isAtBottom);
    };

    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [shouldApplyScroll]);

  return (
    <div>
      <div className="bg-white p-6 rounded-lg border border-[#ccc] form-section md:mt-[43px]">
        <h3 className="text-xl font-medium">Order Summary</h3>
        <hr className="my-5" />
        <div className="relative">
          <div
            className={`${
              cart.length >= 9 ? "overflow-y-scroll max-h-[288px]" : ""
            }`}
            ref={scrollContainerRef}
          >
            {Object.entries(categorizedCart).map(([category, items]) =>
              items.length > 0 ? (
                <div key={category} className="mb-4">
                  <h3 className="font-semibold text-black mb-1">{category}</h3>
                  {items.map((item) => (
                    <div
                      key={item.meal.id}
                      className="flex justify-between my-1 gap-2"
                    >
                      <p>
                        {item.quantity} x {item.meal.fields["Name"]}
                      </p>
                      <p className="min-w-[100px] text-right">
                        {formatPrice(
                          item.quantity *
                            item.meal.fields[config.itemPriceFieldTTC]
                        )}{" "}
                        €
                      </p>
                    </div>
                  ))}
                </div>
              ) : null
            )}
            {showDeliveryFee && (
              <div className="flex justify-between">
                <p>Delivery</p>
                <p>{formatPrice(deliveryFee)} €</p>
              </div>
            )}
          </div>

          {cart.length >= 9 && (
            <div
              className={`absolute bottom-0 left-0 w-full h-10 bg-gradient-to-t from-white to-transparent pointer-events-none transition-opacity duration-300 ${
                atBottom ? "opacity-0" : "opacity-100"
              }`}
            />
          )}
        </div>

        {showPartnerDiscount && totalDiscount > 0 && (
          <div className="flex justify-between mt-4">
            <p>Partner Discount</p>
            <p>-{formatPrice(totalDiscount)} €</p>
          </div>
        )}
        <hr className="my-5" />
        <div className="flex justify-between font-bold my-2 text-lg">
          <p>Total to pay</p>
          <p>{formatPrice(totalPriceDisplay)} €</p>
        </div>
        <div className="flex justify-between">
          <p>Taxes</p>
          <p>{formatPrice(totalPriceDisplay - totalPriceHT)} €</p>
        </div>
        <div className="flex justify-between">
          <p>Total excl. taxes</p>
          <p>{formatPrice(totalPriceHT)} €</p>
        </div>
      </div>
      <div className="pt-4 text-sm text-center hidden md:block">
        {noCheckout
          ? "Your order will be validated shortly."
          : "You will receive a confirmation email as soon as your payment is processed."}
      </div>
    </div>
  );
}

export default OrderSummarySidebar;
